import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import SelectedLocationDisplay from '../../SelectedLocationDisplay';
import WishlistIcon from '@/components/Icons/WishlistIcon';

type TCartItemListHeaderProps = {
	children?: React.ReactNode;
};

const CartPageHeader = (props: TCartItemListHeaderProps) => {
	const router = useRouter();

	function navigateToHome() {
		router.push('/');
	}

	function navigateToWishlists() {
		router.push('/my/wishlist');
	}

	return (
		<FlexBox
			p='26px 40px'
			fullWidth
			sx={{
				position: 'sticky',
				width: '100%',
				left: '0px',
				top: '0px',
				boxShadow: '0 4px 12px 0 rgba(0,0,0,.05)',
				background: 'linear-gradient(180deg, #F3F3F3 0%, #FFFFFF 99.38%);',
				zIndex: 999,
			}}
		>
			<FlexBox
				id='header-content'
				alignItems={'center'}
				justifyContent='space-between'
				fullWidth
			>
				<Box
					className='cursor-pointer'
					sx={{ height: '20px', width: '188px', cursor: 'pointer' }}
					mr='27px'
					onClick={navigateToHome}
				>
					<img
						style={{ width: '100%' }}
						src='https://assets.furlenco.com/s3-furlenco-images/yoda/furlenco-logo.png'
					/>
				</Box>
				<FlexBox alignItems='center'>
					<SelectedLocationDisplay />
					<Box ml='32px'>
						<WishlistIcon onClick={navigateToWishlists} />
					</Box>
				</FlexBox>
			</FlexBox>
		</FlexBox>
	);
};

export default CartPageHeader;
